import { Steps,Modal,Button,Spin,DatePicker,Skeleton  } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'
import state from "./components/store"
import Booking from './components/app.vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import { createApp } from "vue";
const app = createApp({
  components: {
    Booking,
  }
});
app.use(VueTelInput)
app.use(Steps)
app.use(state)
app.use(Modal);
app.use(DatePicker)
app.use(Spin);
app.use(Skeleton);
app.use(Button)
app.mount("#app");